import { Icon } from '@design-system';

import { DetailsAddress } from '../types';
import {
  formatAddressLocality,
  formatAddressName,
  formatAddressStreet,
} from '../utils/format';

export type SavedAddressCardProps = {
  address: DetailsAddress;
  editLabel: string;
  onEdit: () => void;
};

export const SavedAddressCard = ({
  address,
  editLabel,
  onEdit,
}: SavedAddressCardProps) => (
  <button
    aria-label={editLabel}
    className="flex w-full flex-row items-center justify-between gap-3 rounded-sm border border-neutral-2 p-4 text-left"
    onClick={onEdit}
    type="button"
  >
    <div className="flex min-w-0 flex-col">
      <span className="truncate">{formatAddressName(address)}</span>
      <span className="truncate text-neutral-4">
        {formatAddressStreet(address)}
      </span>
      <span className="truncate text-neutral-4">
        {formatAddressLocality(address)}
      </span>
    </div>

    <Icon className="shrink-0" name="ic_edit" size="sm" />
  </button>
);
